// import { clearStorage, getLoggedInUserData } from '@/utils/storage';
import { UserOutlined, CloseOutlined, ArrowRightOutlined, ArrowLeftOutlined, MenuOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Divider } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { clearStorage, getRealm } from 'utils/storage';
import SelectStore from 'components/SelectStore';
import { authSdk } from '../../lib/auth';

import './style.css';
import useWindowSize from 'utils/useWindowSize';
const NavBar = ({ children, NavMenus }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [size] = useWindowSize();
  const currentPath = location.pathname;
  const currentYear = new Date().getFullYear();
  const [collapsed, setCollapsed] = useState(false);
  const ref = useRef(null);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = async () => {
    const realm = getRealm();
    await authSdk.logout(realm);
    clearStorage();
    navigate('/auth/login');
  };

  const storeSelector = () => (
    <div className='navbar-selector mr-4'>
      {window.innerWidth < 768 ? (
        <div className='custom-select'>
          <SelectStore className='rounded-lg' onChange={() => {}} />
        </div>
      ) : (
        <SelectStore className='rounded-lg' onChange={() => {}} />
      )}
    </div>
  );

  const items = [
    {
      label: 'Logout',
      key: '1',
    },
  ];
  const menuItems = NavMenus?.map((item) => {
    return {
      key: `/menu-${item?.url}`,
      label: !item?.sabMenus?.length ? (
        <Link
          to={item?.url}
          onClick={() => {
            if (size < 768 && collapsed && !item?.sabMenus?.length) {
              setCollapsed(false);
            }
          }}>
          {item?.title}
        </Link>
      ) : (
        item?.title
      ),
      icon: item?.icon,
      ...(item?.sabMenus?.length && {
        children: item?.sabMenus?.map((sub) => ({
          key: sub.url,
          label: (
            <Link
              to={sub?.url}
              onClick={() => {
                if (size < 768 && collapsed) {
                  setCollapsed(false);
                }
              }}>
              {sub?.title}
            </Link>
          ),
          icon: sub?.icon,
        })),
      }),
    };
  });
  const findActiveKeys = () => {
    const currentPathKey = `/menu-${currentPath}`;
    for (const item of menuItems) {
      let activeKeys = [];
      if (item?.key === currentPathKey) {
        activeKeys.push(item?.key);
      }
      if (item?.children) {
        for (const sub of item?.children) {
          if (sub.key === currentPath) {
            activeKeys.push(item?.key, sub?.key);
            return activeKeys;
          }
        }
      }
      if (activeKeys?.length) return activeKeys;
    }
    return [];
  };
  useEffect(() => {
    if (size >= 860 || size < 860) {
      setCollapsed(false);
    }
  }, [size]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setCollapsed(false);
        document.removeEventListener('mousedown', handleClickOutside);
      }
    };

    if (collapsed && size < 860) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [collapsed]);

  return (
    <div className={`flex flex-col h-screen ${collapsed ? 'sidebar-section' : ''}`}>
      {/* navbar */}
      {size >= 860 ? (
        <div className='h-[62px] bg-[#FFFFFF00] flex border-[#E5E5E5] flex-shrink-0 w-full'>
          <div className={`${collapsed ? 'w-16 max-[990px]:w-16' : 'w-64 max-[990px]:w-[200px]'} p-3 flex items-center justify-start`}>
            <img src='/xpayLogoS.svg' alt='logo' className='' /> {!collapsed && <img src='/pay-logo.svg' alt='logo' className='h-[24px] w-[34px] pl-1' />}
          </div>
          {collapsed ? (
            <ArrowRightOutlined
              onClick={toggleCollapsed}
              style={{
                position: 'absolute',
                top: '50px',
                background: '#F0F0F0',
                padding: '5px',
                borderRadius: '100px',
                zIndex: 50,
                left: `${collapsed ? '53px' : '245px'}`,
                transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          ) : (
            <ArrowLeftOutlined
              onClick={toggleCollapsed}
              style={{
                position: 'absolute',
                top: '50px',
                background: '#F0F0F0',
                padding: '5px',
                borderRadius: '100px',
                zIndex: 50,
                left: `${collapsed ? '53px' : '245px'}`,
                transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          )}
          <div className='flex items-center justify-end flex-grow border-b-[1px]'>
            {/*    <div className='flex h-full items-center pl-6 gap-2'>
              <span className='text-[20px] font-[600] leading-[40px]'>{'Payment Gateway Solution'}</span>
            </div> */}

            <div className='flex h-full items-center p-4 pr-6 gap-2'>
              {!currentPath?.includes('users') && <div>{storeSelector()}</div>}
              <div className='flex items-center gap-4'>
                <Dropdown menu={{ items, onClick: handleLogout }} trigger={['click']}>
                  <div className='user-image'>
                    <UserOutlined />
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='flex flex-col border-b-[1px] border-[#E5E5E5] flex-shrink-0 w-full bg-[#fff] mobile-sidebar' ref={ref}>
          <div className='flex items-center justify-between w-full px-4'>
            {!collapsed ? <MenuOutlined onClick={toggleCollapsed} /> : <CloseOutlined onClick={toggleCollapsed} />}
            <div className={`p-3 flex items-center justify-center`}>
              <img src='/XPayNL.svg' alt='logo' className='w-[60px] h-[50px]' />
            </div>
            <div className='flex items-center justify-between gap-2'>
              {!currentPath?.includes('users') && <div>{storeSelector()}</div>}
              <div className='flex items-center gap-2'>
                <Dropdown menu={{ items, onClick: handleLogout }} trigger={['click']}>
                  <div className='user-image'>
                    <UserOutlined />
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>
          <div
            className={`absolute left-0 top-[74px] w-[100vw] h-[100vh] bg-white shadow-lg border border-gray-300 z-50
    transition-all duration-500 ease-in-out transform origin-top
    ${collapsed ? 'scale-y-100 opacity-100' : 'scale-y-0 opacity-0 pointer-events-none'}`}>
            <Menu subMenuCloseDelay={1} subMenuOpenDelay={1} defaultSelectedKeys={findActiveKeys()} defaultOpenKeys={findActiveKeys()} mode='inline' items={menuItems} />
          </div>
        </div>
      )}
      {/* end navbar */}

      {/* Content container */}
      <div className='flex overflow-hidden'>
        {size >= 860 && (
          <div
            className={` animated-sidebar h-[100vh] bg-[#FFFFFF00] transition-all duration-500 flex flex-col border-[#E5E5E5] manues pt-6 m-0 custom-sidebar  flex-shrink-0 ${
              collapsed ? 'w-16 max-[990px]:w-16 p-3 closed-sidebar' : 'w-64 max-[990px]:w-[200px] justify-between open-sidebar'
            }`}>
            <Menu inlineCollapsed={collapsed} subMenuCloseDelay={1} subMenuOpenDelay={1} defaultSelectedKeys={findActiveKeys()} defaultOpenKeys={findActiveKeys()} mode='inline' items={menuItems} />
            {!collapsed && (
              <div className=' sticky bottom-0 bg-[#fff]'>
                <Divider style={{ borderColor: '#000000', marginBottom: '8px', marginTop: '0' }} />
                <div className='flex flex-col  gap-[8px] justify-left items-left mt-[0] md:justify-start md:mt-[0]' style={{ alignItems: 'center' }}>
                  <p className='text-[10px] font-medium mb-[-0.3125vw] md:text-[10px] text-[#00000] '>
                    <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='text-black hover:text-black'>
                      {' '}
                      ©{currentYear} PostEx.
                    </a>
                  </p>
                  <div className='gap-[0.3125vw] text-[#00000] text-[10px] font-medium flex flex-row md:gap-[0.8vw] md:text-[10px] pb-3'>
                    <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='text-black hover:text-black'>
                      Terms of Service
                    </a>
                    {'|'}
                    <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='text-black hover:text-black'>
                      {' '}
                      Privacy Policy
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Main Content */}
        <div className='p-4 h-full flex-grow overflow-auto relative' style={{ background: '#F5F5F5' }}>
          {children}
        </div>
        {/* end Main Content */}
      </div>
      {/* End Content container */}
    </div>
  );
};

export default NavBar;
